/* Delivery preferences share the cart evaluation; unknown never clears customer input. */
class ReservationCartDeliverySchedule extends HTMLElement {
  connectedCallback() {
    this.store = window.Plus2doShipping;
    if (!this.store) return;
    this.dateSelect = this.querySelector('[data-delivery-date]');
    this.slotSelect = this.querySelector('[data-delivery-slot]');
    this.status = this.querySelector('[data-delivery-status]');
    this.onChange = () => this.store.select(this.dateSelect.value, this.slotSelect.value);
    this.dateSelect.addEventListener('change', this.onChange);
    this.slotSelect.addEventListener('change', this.onChange);
    this.unsubscribe = this.store.subscribe((state) => this.render(state));
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    this.dateSelect?.removeEventListener('change', this.onChange);
    this.slotSelect?.removeEventListener('change', this.onChange);
  }
  fill(select, options, saved, enabled) {
    const key = JSON.stringify([options, saved, enabled]);
    if (select.shippingOptionsKey !== key) {
      const fragment = document.createDocumentFragment();
      const append = (value, label) => { const option = document.createElement('option'); option.value = value; option.textContent = label; fragment.appendChild(option); };
      append('', this.store.messages.unspecified);
      options.forEach((option) => append(option.value, option.label));
      // Preserve unknown or failed-save preference visibly without claiming it is selectable.
      if (saved && !options.some((option) => option.value === saved)) append(saved, saved);
      select.replaceChildren(fragment);
      select.value = saved || '';
      select.shippingOptionsKey = key;
    }
    select.disabled = !enabled;
  }
  render(state) {
    const ready = state.status === 'ready';
    const dates = ready ? state.data.dates : [];
    const slots = ready ? state.data.timeSlots.map((slot) => ({ value: slot, label: slot })) : [];
    const attributes = this.store.draft || state.attributes;
    this.hidden = state.status === 'empty';
    this.querySelector('[data-delivery-panel]').hidden = false;
    this.fill(this.dateSelect, dates, attributes['配達希望日'] || '', ready && dates.length > 0);
    this.fill(this.slotSelect, slots, attributes['配達希望時間帯'] || '', ready && slots.length > 0);
    this.querySelector('[data-delivery-fields]').hidden = ready && !dates.length && !slots.length;
    this.status.textContent = (!ready && !['error', 'evaluationError', 'saving'].includes(state.saveStatus)) ? this.store.messages.preferencesUnverified : this.store.messages[state.saveStatus] || (ready && !dates.length && !slots.length
      ? this.store.messages.unavailable : !ready ? this.store.messages.preferencesUnverified : this.store.messages.provisional);
  }
}
if (!customElements.get('reservation-cart-delivery-schedule')) customElements.define('reservation-cart-delivery-schedule', ReservationCartDeliverySchedule);
